"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_redux_1 = require("react-redux");
var react_router_dom_1 = require("react-router-dom");
var react_i18next_1 = require("react-i18next");
var ProfileButton_1 = __importDefault(require("./ProfileButton"));
var loginSlice_1 = require("../../../features/login/loginSlice");
var globalSlice_1 = require("../../../features/global/globalSlice");
var useActionForbidden_1 = require("../../../hooks/useActionForbidden");
var Routes_1 = require("../../../constants/Routes");
var HeaderNavigation_1 = __importDefault(require("./HeaderNavigation"));
var Logo_1 = __importDefault(require("../../Logo/Logo"));
var hamburger_svg_1 = __importDefault(require("../../../../images/hamburger.svg"));
var deviceHelper_1 = require("../../../helpers/deviceHelper");
var GeneralSettings_1 = require("../../../constants/GeneralSettings");
var BottomHeader = function (_a) {
    var openMobileMenu = _a.openMobileMenu, openAccountList = _a.openAccountList, onDismiss = _a.onDismiss, user = _a.user, open = _a.open, isAnnouncementPage = _a.isAnnouncementPage, currentLanguage = _a.currentLanguage;
    var t = react_i18next_1.useTranslation('common').t;
    var history = react_router_dom_1.useHistory();
    var loginModalIsOpen = react_redux_1.useSelector(loginSlice_1.selectLoginModalIsOpen);
    var isShowHeaderActions = react_redux_1.useSelector(globalSlice_1.getIsShowHeaderActions);
    var dispatch = react_redux_1.useDispatch();
    var openAnnouncement = useActionForbidden_1.useActionForbidden(function () {
        history.push(Routes_1.Routes.Announcement.path);
    });
    return (react_1.default.createElement("div", { className: "bottom" },
        react_1.default.createElement("div", { className: "container" },
            react_1.default.createElement("div", { className: "left-side" },
                react_1.default.createElement("nav", null,
                    react_1.default.createElement("div", { className: 'hamburger', onClick: openMobileMenu },
                        react_1.default.createElement("img", { src: hamburger_svg_1.default, alt: "hamburger" })),
                    react_1.default.createElement(Logo_1.default, { currentLanguage: currentLanguage }),
                    isShowHeaderActions && !deviceHelper_1.isMobile() && (react_1.default.createElement(HeaderNavigation_1.default, null)))),
            react_1.default.createElement("div", { className: "right-side" },
                !isAnnouncementPage && (react_1.default.createElement("a", { onClick: openAnnouncement, className: "btn btn-primary" }, t('HEADER.Button'))),
                react_1.default.createElement("div", { className: "right-side-icons" },
                    !isAnnouncementPage && (react_1.default.createElement("a", { className: "cm-icon icon-phone", href: "tel:" + GeneralSettings_1.GENERAL_SETTINGS.CONTACT_PHONE.PHONE_NUMBER })),
                    isShowHeaderActions && (react_1.default.createElement("div", { className: "avatar-icon" },
                        react_1.default.createElement(ProfileButton_1.default, { user: user, open: open, openAccountList: openAccountList, onDismiss: onDismiss }))),
                    loginModalIsOpen ? (react_1.default.createElement("span", { className: "close-login-modal" },
                        react_1.default.createElement("i", { onClick: function () {
                                dispatch(loginSlice_1.closeLoginFormModal());
                            }, className: "cm-icon icon-close" }))) : (''))))));
};
exports.default = BottomHeader;
